import contentTypes from "@/view/constants/contentTypes";
import getLanguageCode from "@/view/utils/getLanguageCode";

const findMatchingTextSetMember = (
  textSet,
  contentId,
  contentType,
  currentLevel,
) => {
  const contentIsVideo = contentType === contentTypes.INTERACTIVE_VIDEO;

  return textSet?.members.find((member) => {
    if (contentIsVideo) {
      return member.content_id === contentId;
    }

    return (
      member.story_content_id === contentId &&
      member.language === getLanguageCode(currentLevel?.language)
    );
  });
};

export default findMatchingTextSetMember;
